<div class="activity__row">
  <div class="column--status">
    <div class="column__status"></div>
  </div>
  <div class="column--action d-flex" [ngSwitch]="model.type">
    <ng-container *ngIf="model.attendeeType === 0; else inPersonIcon">
      <div class="attendee-type">
        <app-icon-virtual></app-icon-virtual>
      </div>
    </ng-container>

    <ng-template #inPersonIcon>
      <div class="attendee-type">
        <app-icon-in-person></app-icon-in-person>
        <div *ngIf="model.inPersonPaddleNum" class="in-person-paddle-number"> {{ '#' + model.inPersonPaddleNum }}</div>
      </div>
    </ng-template>

    <div class="column__value--action text-truncate" *ngSwitchCase="'pledge'">Pledge of {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
    <div class="column__value--action text-truncate" *ngSwitchCase="'sold'">Sold for {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
    <div class="column__value--action text-truncate" *ngSwitchCase="'recurring'">Recurring for {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
    <div class="column__value--action text-truncate" *ngSwitchCase="1">Bid of {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
    <div class="column__value--action text-truncate" *ngSwitchCase="2">Winner Declared</div>
    <div class="column__value--action text-truncate" *ngSwitchCase="3">Last Hero Declared</div>
    <div class="column__value--action text-truncate" *ngSwitchCase="4">Live Item changed</div>
    <div class="column__value--action text-truncate" *ngSwitchCase="5">Silent Auction closed</div>
    <div class="column__value--action text-truncate" *ngSwitchCase="6">Sell More of {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
  </div>
  <div class="column--target">
    <div class="column__value--target text-truncate">{{ model.data.name }}</div>
  </div>
  <div class="column--time">
    <div class="column__value--time text-truncate">{{ model.timer$ | async | activityTimer:index }}</div>
  </div>
</div>
